export default __webpack_public_path__ + "static/media/remittance.b745194f.png";